import {instance, onErrorFunction} from "../../config/axios-cnf";

export const apiGetEvents = (subjectId, callback, error) => {
    instance.get("/api/v2/arena", {params: {subjectId}})
        .then(response => callback(response.data))
        .catch(err => error(err))
}

export const apiGetEntrancesForEvent = (subjectId, eventId,page,perPage,isExport=false, callback,error)=>{
    instance.get("/api/v2/arena/entrances", {params: {subjectId: subjectId, eventId: eventId,page:page,perPage:perPage,isExcel:isExport}})
        .then(response => callback(response.data))
        .catch(err => error(err))
}
